import axios from 'axios';

let _cache = null;
let _pending = null;

// 앱 시작 시 사전 조회
export const preload = () => {
    if (!_pending) {
        _pending = new Promise((resolve) => {
            getCurrentPosition(
                (coords) => resolve(coords),
                () => resolve(null)
            );
        });
    }
};

const _getByGPS = () => {
    return new Promise((resolve, reject) => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
                () => reject(),
                { timeout: 10000, maximumAge: 300000, enableHighAccuracy: true }
            );
        } else {
            reject();
        }
    });
};

const _getByIP = () => {
    return axios.get("https://ipapi.co/json/", { timeout: 5000 })
        .then((response) => {
            let data = response.data;
            if (data && typeof data.latitude === "number" && typeof data.longitude === "number") {
                return { latitude: data.latitude, longitude: data.longitude };
            }
            throw new Error("IP 위치 조회 실패");
        });
};

// GPS 우선, 실패 시 IP 폴백
export const getCurrentPosition = (succFunc, errFunc) => {
    if (_cache) {
        succFunc(_cache);
        return;
    }

    if (_pending) {
        let pending = _pending;
        _pending = null;
        pending.then((coords) => {
            if (coords) {
                _cache = coords;
                succFunc(coords);
            } else {
                errFunc && errFunc();
            }
        });
        return;
    }

    _getByGPS()
        .then((coords) => {
            _cache = coords;
            succFunc(coords);
        })
        .catch(() => {
            _getByIP()
                .then((coords) => {
                    _cache = coords;
                    succFunc(coords);
                })
                .catch(() => {
                    errFunc && errFunc();
                });
        });
};
